
const logicCondition = {
    remarksRequired: [
        'TR',
        'CA',
        'ME',
        'DSR',
        'ASS',
        'MPW',
        'RES',
        'STS',
        'MNG'
    ],
    bypassStage: [
        'open',
        'hold',
        'assigned',
        'qcpass',
        'qcfail'
    ],
    commonAccountCode: 'CFA',
    vacationCode: [
        'VAC',
        'PTA',
        'LOP'
    ]
}
export default logicCondition;